import { useEffect, useState, useRef } from "react";

import EditMediaHotspot from "./types/EditMediaHotspot";
import EditStickerHotspot from "./types/EditStickerHotspot";
import EditExternalHotspot from "./types/EditExternalHotspot";
import EditAudioHotspot from "./types/EditAudioHotspot";
import EditGalleryHotspot from "./types/EditGalleryHotspot";
import EditLinkHotspot from "./types/EditLinkHotspot";
import EditFadeHotspot from "./types/EditFadeHotspot";
import EditElevateUpHotspot from "./types/EditElevateUpHotspot";
import EditElevateDownHotspot from "./types/EditElevateDownHotspot";
import EditLookAtHotspot from "./types/EditLookAtHotspot";
import EditTimelineHotspot from "./types/EditTimelineHotspot";

const EditHotspot = ({ type, ...props }) => {
  const [hide, setHide] = useState(!props.show);
  const ref = useRef();

  const show = props.show;

  // force clear data when changing to hotspot
  // of the same type, otherwise the previous
  // hotspot's data is shown
  useEffect(() => {
    if (show) {
      setHide(false);
    } else {
      ref.current = setTimeout(() => setHide(true), 200);
    }

    return () => clearTimeout(ref.current);
  }, [show]);

  if (hide) return null;

  switch (type) {
    case "media":
      return <EditMediaHotspot {...props} />;
    case "sticker":
      return <EditStickerHotspot {...props} />;
    case "web":
      return <EditExternalHotspot {...props} />;
    case "audio":
      return <EditAudioHotspot {...props} />;
    case "gallery":
      return <EditGalleryHotspot {...props} />;
    case "link":
      return <EditLinkHotspot {...props} />;
    case "fade":
      return <EditFadeHotspot {...props} />;
    case "elevate-up":
      return <EditElevateUpHotspot {...props} />;
    case "elevate-down":
      return <EditElevateDownHotspot {...props} />;
    case "poi":
      return <EditLookAtHotspot {...props} />;
    case "timeline":
      return <EditTimelineHotspot {...props} />;
    default:
      if (type) console.info(`"${type}" hotspot not found`);
      return null;
  }
};

export default EditHotspot;
